import React from 'react';
import EditButton from 'components/Edit-Button';
import ViewButton from 'components/View-Button';

export const actionButton = ({ id: id }, adminStatus, accountId, translate) => {
  const adminsButton = (
    <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
      <div style={{ display: 'flex' }}>
        <EditButton link={`/edit-meeting?id=${id}&acc=${accountId}`} />
      </div>

      <div style={{ display: 'flex' }}>
        <ViewButton link={`/meeting?id=${id}&acc=${accountId}`} />
      </div>
    </div>
  );

  const clientButton = (
    <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
      <ViewButton link={`/meeting?id=${id}&acc=${accountId}`} />
    </div>
  );

  if (adminStatus === 'Super Admin' || adminStatus === 'Admin') return adminsButton;

  return clientButton;
};
